import * as React from 'react';
import { observer } from 'mobx-react';
import { IGeneralSummaryProps } from './IGeneralSummaryProps';
import { GeneralSummaryItem } from '../GeneralSummaryItem/GeneralSummaryItem';
import { GetParameter } from 'MeasurementsCalculations';
import { ReportKind } from 'Data';

@observer
export class GeneralSummary extends React.Component<IGeneralSummaryProps> {
  constructor(props: IGeneralSummaryProps) {
    super(props, undefined);
  }

  addSignToHandicap(handicap: string): string {
    if (parseInt(handicap) >= 0) {
      return handicap;
    } else {
      const parsed = Math.abs(parseInt(handicap));
      if (!isNaN(parsed)) {
        return (handicap = '+' + parsed);
      } else {
        return (handicap = '');
      }
    }
  }

  getValueInChosenUnit(value: number, propertyName: string) {
    if (propertyName) {
      return this.props.unitPresentation?.toString(GetParameter(propertyName), value);
    } else {
      return null;
    }
  }

  getParameterUnit(propertyName: string) {
    return this.props.unitPresentation?.displayUnit(GetParameter(propertyName));
  }

  render() {
    const testDefinitionExists = this.props.testResult?.definition;
    const playerName = this.props.player?.name ? this.props.player.name : '';
    const displayedDate = this.props.reportDate ? this.props.reportDate.toLocaleDateString() : '';
    const playerAge = this.props.player?.age ? this.props.player.age : '';
    const handicap = this.props.player?.handicap
      ? this.addSignToHandicap(this.props.player.handicap)
      : '';
    const wind = this.props.testResult.definition?.wind
      ? this.props.testResult.definition.wind
      : '';
    const mode = testDefinitionExists
      ? this.props.testResult.definition.indoorTest === true
        ? 'Indoor'
        : 'Outdoor'
      : '';

    const temperature =
      testDefinitionExists && this.props.testResult.definition.temperature
        ? this.getValueInChosenUnit(this.props.testResult.definition.temperature, 'Temperature')
        : '';
    const temperatureUnit =
      testDefinitionExists && this.props.testResult.definition.temperature
        ? this.getParameterUnit('Temperature')
        : '';
    const ball = this.props?.ball ? this.props.ball : '';
    return (
      <div className={this.props.className}>
        <div className="row player-and-name">
          <GeneralSummaryItem
            name="Player"
            value={playerName}
            className="player GeneralSummaryItem col-xs-7"
          />
          <GeneralSummaryItem
            name="Date"
            value={displayedDate}
            className="date GeneralSummaryItem col-xs-5"
          />
        </div>
        <div className="separation-line"></div>
        <div className="row age-hcp-wind">
          <GeneralSummaryItem
            name="Age"
            value={playerAge}
            className="age GeneralSummaryItem col-xs-4"
          />
          <GeneralSummaryItem
            name="Hcp"
            value={handicap}
            className="hcp GeneralSummaryItem col-xs-4"
          />
          <GeneralSummaryItem
            name="Wind"
            value={wind}
            className="wind GeneralSummaryItem col-xs-4"
          />
        </div>
        <div className="row mode-ball-temp">
          <GeneralSummaryItem
            name="Mode"
            value={mode}
            className="mode GeneralSummaryItem col-xs-4"
          />
          <GeneralSummaryItem
            name="Ball"
            value={ball}
            className="ball GeneralSummaryItem col-xs-4"
          />
          <GeneralSummaryItem
            name="Temp."
            value={temperature}
            unit={temperatureUnit}
            className="temp GeneralSummaryItem col-xs-4"
          />
        </div>
        {this.props.numberOfDeletedStrokes !== null &&
          this.props.numberOfDeletedStrokes !== undefined &&
          this.props.numberOfDeletedStrokes !== 0 &&
          this.props.reportKind === ReportKind.combineTestReport && (
            <div className="deleted-shots">
              <span>Number of deleted shots: </span>
              <span>{this.props.numberOfDeletedStrokes}</span>
            </div>
          )}
      </div>
    );
  }
}
